import styled, { css } from 'styled-components';

interface GridCellContainerProps {
  rowHeight: string;
}
interface PickListButtonProps {
  show: boolean;
}

export const PickListButtonStyled = styled.div<PickListButtonProps>`
  align-items: center;
  justify-content: center;
  align-self: center;
  position: absolute;
  top: 1px;
  height: 22px;
  width: 26px;
  cursor: pointer;
  ${({ theme, show }) =>
    css`
      display: ${show ? 'flex' : 'none'};
      border-radius: ${theme.spacings[100]};
      right: ${theme.spacings[200]};
      background-color: ${theme.colors.primary[200]};
    `}
`;

export const GridCellContainer = styled.div<GridCellContainerProps>`
  ${({ rowHeight }) =>
    css`
      height: ${rowHeight}px;
    `}
`;
